<template>
  <div style="margin-top:2%; width:90%">
    <v-data-table
      :headers="headers"
      :items="showAll ? usersList : usersList.filter((i) => i.isActive == 1)"
      :search="search"
      sort-by="email"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Üye listesi</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-select
            v-model="selectedCompany"
            label="Firma"
            style="margin: 0 2.5%;"
            :items="companyList"
            item-value="id"
            hide-details
            item-text="name"
            @change="loadUsersList(selectedCompany)"
            :rules="[rules.required]"
          ></v-select>
          <v-col>
            <v-btn
            :disabled="selectedCompany == null"
            text
            @click="changeSessionStatus(!currentCompany.loggedinUserFlag)"
            >Oturum Durumu &nbsp;
            <v-icon
              >{{currentCompany.loggedinUserFlag?'lock':'lock_open'}}</v-icon
            >
          </v-btn>
          </v-col>
          
          <v-switch
            :disabled="selectedCompany == null"
            v-model="showAll"
            :dense="false"
            style="padding-top: 30px;margin-right:1%"
          >
            <template #prepend>
              <v-label><center>Tümünü Göster</center></v-label>
            </template>
          </v-switch>
          <v-btn
            outlined
            color="primary"
            :disabled="selectedCompany == null"
            style="margin-right:1%;"
            @click="companyInfoDialog = !companyInfoDialog"
            ><v-icon>work_outline</v-icon></v-btn
          >
          <v-dialog v-model="companyInfoDialog" width="60%">
            <v-card>
              <v-tabs v-model="CompanyInfoTab">
                <v-tab>Yeminli Mali Müşavir Bilgileri</v-tab>
                <v-tab>Program Ayarları</v-tab>
              </v-tabs>
              <v-tabs-items v-model="CompanyInfoTab">
                <v-tab-item>
                  <v-card flat>
                    <CharteredAccountant
                      :popUpStatus="companyInfoDialog"
                      @refresh-company="refreshCompanyById"
                      :company="currentCompany"
                    />
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <CompanySettings
                      :popUpStatus="companyInfoDialog"
                      @refresh-company="refreshCompanyById"
                      :company="currentCompany"
                    />
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-dialog>
          <v-dialog v-model="periodDialog" width="35%" persistent>
              <v-card>
                <v-card-title>
                  <span>{{ periodText }}</span>
                </v-card-title>
                <v-form v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="6" style="padding-left: 12;padding-right: 12;padding-bottom: 0;padding-top: 0">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="startingPeriod"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="startingPeriod"
                              :label="fieldText"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="startingPeriod"
                            type="month"
                            scrollable
                            locale="tr"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal = false">İptal</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(startingPeriod)">Tamam</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                      <v-col v-if="!demoAccount" cols="12" md="6" style="padding-left: 12;padding-right: 12;padding-bottom: 0;padding-top: 0">
                        <v-dialog
                          ref="dialog1"
                          v-model="modal1"
                          :return-value.sync="endPeriod"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="endPeriod"
                              label="Bitiş Tarihi"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules="[rules.required]"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="endPeriod"
                            type="month"
                            scrollable
                            locale="tr"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal1 = false">İptal</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog1.save(endPeriod)">Tamam</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="periodDialogClose(0)">İptal</v-btn>
                  <v-btn
                    :disabled="!valid"
                    color="blue darken-1"
                    text
                    @click="periodDialogClose(1)"
                    >Kaydet</v-btn
                  >
                </v-card-actions>
              </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" width="60%">
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="selectedCompany == null"
                outlined
                color="primary"
                v-on="on"
                ><v-icon>group_add</v-icon></v-btn
              >
              
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Yeni Üye Kaydı</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="newUser">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="newUserTemplate.name"
                          label="Kullanıcı Adı"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="newUserTemplate.email"
                          label="E-mail"
                          :rules="[rules.required, rules.email]"
                        ></v-text-field>
                      </v-col>
                         <v-col cols="12" md="3">
                        <v-select v-model="addMultiUser" :items="allUser" label="Tüm Kullanıcılar" multiple>
                            <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                            <span>{{ item }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption">
                            (+{{ addMultiUser.length - 1 }} diğerleri)
                            </span>
                           </template>
                          </v-select>
                          </v-col>
                      <v-checkbox
                        style="margin-top:30px; margin-left:3%"
                        v-model="demoAccount"
                        label="Demo Hesap"
                      ></v-checkbox>
                      <v-checkbox
                        :disabled="demoAccount"
                        style="margin-top:30px; margin-left:3%"
                        v-model.number="isAdmin"
                        label="Admin"
                      ></v-checkbox>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()">İptal</v-btn>
                <v-btn color="blue darken-1" text @click="save()">Kaydet</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog2" width="60%" persistent>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="selectedCompany == null"
                outlined
                color="primary"
                v-on="on"
                ><v-icon>group_add</v-icon></v-btn
              >
              
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Var Olan Kullanıcı Ekle</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="allUserAdd">
                  <v-container>
                    <v-row>
                         <v-col cols="4" md="7">
                        <v-select v-model="addMultiUser" :items="allUser" label="Tüm Kullanıcılar" multiple :rules="[rules.addUser]">
                            <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                            <span>{{ item }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption">
                            (+{{ addMultiUser.length - 1 }} diğerleri)
                            </span>
                           </template>
                          </v-select>
                          </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()">İptal</v-btn>
                <v-btn color="blue darken-1" text @click="saveAllUser()">Kaydet</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.isActive="{ item }">
        <v-icon
          medium
          v-if="item.isActive == 1"
          @click="changeStatus(item.id, 0)"
          >check</v-icon
        >
        <v-icon medium v-else @click="changeStatus(item.id, 1)">close</v-icon>
      </template>

      <template v-slot:item.isAdmin="{ item }">
        <v-icon
          medium
          v-if="isAdminAt(item) == true"
          @click="updateAdminStatus(item, 0)"
        >
          check
        </v-icon>
        <v-icon medium v-else @click="updateAdminStatus(item, 1)">
          close
        </v-icon>
      </template>

      <template v-slot:item.block="{ item }">
        <v-icon
          medium
          v-if="item.activationCount > 4"
          @click="processBlockedUser(item.id, 0)"
        >
          block
        </v-icon>
        <v-icon medium v-else @click="processBlockedUser(item.id, 5)">
          panorama_fish_eye
        </v-icon>
      </template>

      <template v-slot:item.companies="{ item }">
        <center>{{ companies(item.id) }}</center>
      </template>

      <template v-slot:item.detay="{ item }">
        <v-icon medium @click="userDetailsModal(item)">description</v-icon>
      </template>
    </v-data-table>

    <v-dialog
      v-model="userDetailsDialog"
      max-width="900"
      style="min-height:1000px;"
    >
      <v-card>
        <v-tabs v-model="userDetailsTab">
          <v-tab>Kullanıcı Bilgileri</v-tab>
          <v-tab>Kullanıcı Haraketleri</v-tab>
          <v-tab>Kullanıcı Yetkileri</v-tab>
        </v-tabs>
        <v-tabs-items v-model="userDetailsTab">
          <v-tab-item>
            <v-card flat>
              <UserDetailsUpdate
                :user="selectedUserDetails"
                :popUpStatus="userDetailsDialog"
                @refresh="loadUsersList(selectedCompany)"
              />
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <LogTable
                :user="selectedUserDetails"
                :company="selectedCompany"
                :popUpStatus="userDetailsDialog"
              />
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <AuthTable
                :user="selectedUserDetails"
                :company="selectedCompany"
                :popUpStatus="userDetailsDialog"
                @refresh="loadUsersList(selectedCompany)"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <Loader></Loader>
  </div>
</template>

<script>
import * as userReq from "../request/user.js";
import LogTable from "./subComponents/LogTable";
import UserDetailsUpdate from "./subComponents/UserDetailsUpdate";
import AuthTable from "./subComponents/AuthTable";
import CharteredAccountant from "./subComponents/CharteredAccountant.vue";
import CompanySettings from "./subComponents/CompanySettings.vue";
import Loader from "./subComponents/loader.vue";
export default {
  components: {
    LogTable, 
    UserDetailsUpdate,
    AuthTable,
    CharteredAccountant,
    CompanySettings,
    Loader,
  },
  data: () => ({
    addMultiUser : [],
    allUser : [],
    dialog2: false , 
    fieldText: "",
    periodText: "",
    modal1: false,
    modal: false,
    valid: false,
    showAll: false,
    dialog: false,
    companyInfoDialog: false,
    userDetailsTab: null,
    CompanyInfoTab: null,
    userDetailsDialog: false,
    selectedUserDetails: {},
    startingPeriod: null,
    endPeriod: null,
    date: null,
    demoAccount: false,
    search: "",
    headers: [
      { text: "Kullanıcı Adı", value: "name", width: "150", align: "center" },
      { text: "E-mail", width: "50", value: "email", align: "center" },
      {
        text: "Aktif/Pasif",
        width: "50",
        value: "isActive",
        sortable: false,
        align: "center",
      },
      {
        text: "Admin",
        width: "50",
        value: "isAdmin",
        sortable: false,
        align: "center",
      },
      {
        text: "Blok",
        width: "50",
        value: "block",
        sortable: false,
        align: "center",
      },
      { text: "Kurum", width: "100", value: "companies", align: "center" },
      { text: "Son Kullanma Tarihi", width: "150", value: "deadLineLogged", align: "center" },
      {
        text: "Detay",
        width: "50",
        value: "detay",
        sortable: false,
        align: "center",
      },
    ],
    rules: {
      required: (value) => !!value || "Gerekli.",
      counter: (value) => value.length >= 5 || "En az 5 karakter",
      addUser: (value) => value.length >= 1 || "Seçim yapınız",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Geçersiz Email";
      },
    },
    usersData: [],
    usersList: [],
    periodDialog: false,
    editedIndex: -1,
    selectedCompany: null,
    newUserTemplate: {
      email: "",
      password: "",
      companyId: null,
      isAdmin: 0,
      isSuperAdmin: false,
      authPermission: {},
      settings: {},
    },
    companyList: [],
  }),
  computed: {
    isAdmin: {
      set: function(val) {
        this.newUserTemplate.isAdmin = val == true ? 1 : 0;
      },
      get: function() {
        return this.newUserTemplate.isAdmin;
      },
    },
    currentCompany() {
      if (!this.selectedCompany){
        return false
      } 
      return this.companyList.filter((c) => c.id == this.selectedCompany)[0];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    "demoAccount": function (value) {
      if (value) {
        this.fieldText = "Girilecek Veri Dönemi"
        this.periodText = "Demo Hesap Kısıtlaması İçin Dönem Giriniz"
        this.isAdmin = false
        this.periodDialog = true
      }
    }
  },
  created() {
    this.loadCompaniesList();
  },
  methods: {
    changeSessionStatus(sessionStatus) {
      userReq
        .updateCompanyProperty(
          this.selectedCompany,
          "loggedinUserFlag",
          sessionStatus
        )
        .then((res) => {
          if (res.data.success) {
            for (let i = 0; this.companyList.length; i++) {
              if (this.companyList[i].id == this.selectedCompany) {
                this.companyList[i].loggedinUserFlag = sessionStatus;
                break;
              }
            }
          }
        });
    },
    changeStatus(id, status) {
      userReq
        .updateUserProp(id, "isActive", status, this.selectedCompany)
        .then((response) => {
          if (response.data.data.value == 1) {
            let index = this.usersList.findIndex((obj) => obj.id == id);
            this.usersList[index].isActive = status;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    userDetailsModal(user) {
      this.selectedUserDetails = user;
      this.userDetailsDialog = true;
    },
    periodDialogClose(type){
        if (this.startingPeriod == null || this.endPeriod == null) {
          this.periodCheckBox = false
        }
        this.periodDialog = false;
        if (type == 0) {
          this.demoAccount = false;
        }
    },
    close() {
      this.dialog = false;
      this.dialog2 = false;
      this.addMultiUser = [];
      this.clearUserTemplate();
    },
    save() {
      if (this.$refs.newUser.validate()) {
        if (this.demoAccount) {
          let demoPeriod = this.startingPeriod.split("-")[1] + "/" + this.startingPeriod.split("-")[0]
            this.newUserTemplate.companyId = this.selectedCompany;
            this.newUserTemplate.settings.demoPeriod = demoPeriod
            this.newUserTemplate.companyName = this.companyList.filter((c) => c.id == this.selectedCompany)[0].name
            userReq.addUser(this.newUserTemplate, this.selectedCompany).then(() => {
              this.close();
              this.loadUsersList(this.selectedCompany);
              this.clearUserTemplate();
            })
            .catch((err) => console.log(err));
        }else{
          this.newUserTemplate.companyId = this.selectedCompany;
          this.newUserTemplate.companyName = this.companyList.filter((c) => c.id == this.selectedCompany)[0].name
          userReq.addUser(this.newUserTemplate, this.selectedCompany).then(() => {
            this.close();
            this.loadUsersList(this.selectedCompany);
            this.clearUserTemplate();
          })
          .catch((err) => console.log(err));
        }
        // this.newUserTemplate.companyId = this.selectedCompany;
        // userReq
        //   .addUser(this.newUserTemplate, this.selectedCompany)
        //   .then(() => {
        //     this.close();
        //     this.loadUsersList(this.selectedCompany);
        //     this.clearUserTemplate();
        //   })
        //   .catch((err) => console.log(err));
      }
    },
    saveAllUser() {
      let that = this
      if (this.$refs.allUserAdd.validate()) {
        this.newUserTemplate.companyId = this.selectedCompany;
        this.newUserTemplate.companyName = this.companyList.filter((c) => c.id == this.selectedCompany)[0].name
        console.log(that.newUserTemplate.companyId);
        userReq.addMultipleUsers(this.addMultiUser , this.newUserTemplate.companyId ,this.newUserTemplate.companyName ).then((response) => {
          if (response.status == 200) {
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "success",
              text: "Kaydedildi",
              timeout: 2500,
            };
            this.close();
            that.allUser = [];
            this.dialog2 = false;
            this.loadUsersList(that.selectedCompany);
            this.clearUserTemplate();
          }else{
            this.$store.state.snackbarErrorObj = {
              snackbar: true,
              color: "error",
              text: "Hata Oluştu",
              timeout: 2500
            };
          }
          
        })
        .catch((err) => console.log(err));
      }
    },
    loadUsersList(companyId) {
      let that = this
      this.$store.commit("LOADER", true);
      userReq
        .getUsersList(companyId)
        .then((response) => {
          let userObj = {}
          this.usersList = response.data.data.value;
          for (let i = 0; i < response.data.data.value.length; i++) {
            response.data.data.value[i].deadLineLogged = new Date(response.data.data.value[i].tUserCompanies[0].tCompany.deadlineLoggedin).toLocaleString().split(" ")[0]
            if (userObj[response.data.data.value[i].email] == undefined) {
              userObj[response.data.data.value[i].email] =  {}
            }
          }
          userReq
            .getAllUserList()
            .then((response) => {
              let emailArray = response.data.data.value;
              for (let i = 0; i < emailArray.length; i++) {
                if (userObj[emailArray[i]] == undefined ) {
                  that.allUser.push(emailArray[i])
                }
              }
              this.$store.commit("LOADER", false);
            })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    companies(id) {
      let relatedUser = this.usersList.filter((user) => user.id == id);
      let companiesList = "";
      relatedUser[0].tUserCompanies.forEach((item, i) => {
        companiesList += `${item.tCompany.name}${
          i == relatedUser[0].tUserCompanies.length - 1 ? "." : ", "
        }`;
      });
      return companiesList;
    },
    loadCompaniesList() {
      userReq
        .getCompanyList()
        .then((response) => {
          console.log(response)
          this.companyList = response.data.data.value;
          this.$store.commit("LOADER", false);
        })
        .catch((err) => console.log(err));
    },
    clearUserTemplate() {
      this.newUserTemplate = {
        email: "",
        password: "",
        companyId: null,
        isAdmin: null,
        isSuperAdmin: false,
        authPermission: {},
        settings: {},
      };
    },
    isAdminAt(user) {
      for (let i = 0; i < user.tUserCompanies.length; i++) {
        if (
          user.tUserCompanies[i].companyId == this.selectedCompany &&
          user.tUserCompanies[i].isAdmin == 1
        ) {
          return true;
        }
      }
      return false;
    },
    updateAdminStatus(user, adminStatus) {
      userReq
        .updateAdminStatus(user.id, this.selectedCompany, adminStatus)
        .then((response) => {
          if (response.data.data.value == 1) {
            let index = this.usersList.findIndex((obj) => obj.id == user.id);
            for (let i = 0; this.usersList[index].tUserCompanies.length; i++) {
              if (
                this.usersList[index].tUserCompanies[i].companyId ==
                this.selectedCompany
              ) {
                this.usersList[index].tUserCompanies[i].isAdmin = adminStatus;
                return;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    processBlockedUser(userId, activationCount) {
      userReq
        .updateUserProp(
          userId,
          "activationCount",
          activationCount,
          this.selectedCompany
        )
        .then((response) => {
          if (response.data.data.value == 1) {
            let index = this.usersList.findIndex((obj) => obj.id == userId);
            this.usersList[index].activationCount = activationCount;
          }
        })
        .catch((err) => console.log(err));
    },
    refreshCompanyById(propName, obj) {
      let index = this.companyList.findIndex((x) => x.id == obj.id);
      this.companyList[index][propName] = obj.value;
    },
  },
};
</script>

<style>
.v-label{
  margin-bottom: 2px;
}
</style>